import { dateTimeParse } from "@gravity-ui/date-utils";

import type { ProductFilters } from "../widgets/ProductFilters/ProductFilters";

const CREATED_DATE_FORMAT = "YYYY-MM-DD";

export const parseCreatedDate = (raw: string) =>
  raw
    ? dateTimeParse(raw, {
        format: CREATED_DATE_FORMAT,
        allowRelative: false,
      })?.toDate()
    : undefined;

export const formatCreatedDate = (date?: Date) =>
  dateTimeParse(date)?.format(CREATED_DATE_FORMAT);

export const toCreatedAtRange = ({
  createdFrom,
  createdTo,
}: Pick<ProductFilters, "createdFrom" | "createdTo">) => ({
  createdAtFrom: dateTimeParse(createdFrom)?.toISOString(),
  createdAtTo: dateTimeParse(createdTo)?.add(1, "day").toISOString(),
});
